import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 微信内部进件跳转的下载页面
  {
    path: "/download",
    name: "Download",
    component: () => import("../views/download"),
    meta: {
      title: "领取额度",
    },
  },
  // 协议页面
  {
    path: "/protocol",
    name: "Protocol",
    component: () => import("../views/protocol"),
    meta: {
      title: "协议",
    },
  },
  // 404页面
  {
    path: "/404",
    name: "NoPage",
    component: () => import("../views/404"),
    meta: {
      title: "404",
    },
  },
  // 了解闪融花介绍页面
  {
    path: "/know",
    name: "Know",
    component: () => import("../views/know"),
    meta: {
      title: "了解闪融花",
    },
  },
  // 关于闪融花
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () => import("../views/app/aboutUs"),
    meta: {
      title: "关于闪融花",
    },
  },
  // 理性消费小课堂
  {
    path: "/classroom",
    name: "Classroom",
    component: () => import("../views/app/classroom"),
    meta: {
      title: "理性消费小课堂",
    },
  },
  // 进件页面
  {
    path: "/registerEntry_tl1",
    name: "RegisterEntryTl1",
    component: () => import("../views/registerEntry_tl1"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  // 默认进件页面
  {
    path: "/registerEntry_tl2",
    name: "RegisterEntryTl2",
    component: () => import("../views/registerEntry_tl2"),
    meta: {
      title: "额度确认",
    },
  },
  // 进件页面(多步骤)
  {
    path: "/registerEntry_tl3",
    name: "RegisterEntryTl3",
    component: () => import("../views/registerEntry_tl3"),
    meta: {
      title: "立即申请",
    },
  },
   // 黄色头部背景进件页面
  {
    path: "/registerEntry_tl4",
    name: "RegisterEntryTl4",
    component: () => import("../views/registerEntry_tl4"),
    meta: {
      title: "额度确认",
    },
  },

   // 蓝色头部背景进件页面
  {
    path: "/registerEntry_tl5",
    name: "RegisterEntryTl5",
    component: () => import("../views/registerEntry_tl5"),
    meta: {
      title: "额度确认",
    },
  },
   //无头部进件页面
  {
    path: "/registerEntry_tl6",
    name: "RegisterEntryTl6",
    component: () => import("../views/registerEntry_tl6"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  // 三方签约结果
  {
    path: "/triContract",
    name: "TriContract",
    component: () => import("../views/triContract"),
    meta: {
      title: "三方签约结果",
    },
  },
  // 此路由为不同项目域名的演示流程进件页面（不调接口）
  {
    path: "/interProRegisterEntry",
    name: "InterProRegisterEntry",
    component: () => import("../views/interProRegisterEntry"),
    meta: {
      title: "三分钟最高可借20万",
    },
  },
  // 此路由为不同项目域名的演示流程完成（不调接口）
  {
    path: "/interProPassedSuccess",
    name: "InterProPassedSuccess",
    component: () => import("../views/interProPassedSuccess"),
    meta: {
      title: "三分钟最高可借20万",
    },
  },
  // 此路由为贷超产品跳转中间页面路由
  {
    path: "/convenientEntrance",
    name: "ConvenientEntrance",
    component: () => import("../views/convenientEntrance"),
    meta: {
      title: "产品推荐",
    },
  },
  // 活动
  {
    path: "/activity",
    name: "Activity",
    meta: {
      title: "",
    },
    component: () => import("../views/activity"),
    children: [
      // 转盘活动页面
      {
        path: "turntable",
        name: "Turntable",
        component: () => import("../views/activity/turntable"),
        meta: {
          title: "幸运大转盘",
        },
      },
      {
        path: "turntable/rule",
        name: "TurntableRule",
        component: () => import("../views/activity/turntable/rule"),
        meta: {
          title: "活动规则",
        },
      },
      {
        path: "turntable/prize",
        name: "TurntablePrize",
        component: () => import("../views/activity/turntable/prize"),
        meta: {
          title: "我的奖品",
        },
      },
    ],
  },
  // H5唤醒APP,
  {
    path: "/openApp",
    name: "OpenApp",
    component: () => import("../views/liftingAPP/openApp"),
    meta: {
      title: "打开闪融花",
    },
  },
  // H5下载页，点击按钮跳应用市场,
  {
    path: "/downloadApp",
    name: "DownloadApp",
    component: () => import("../views/liftingAPP/downloadApp"),
    meta: {
      title: "下载闪融花",
    },
  },
  // 进件结果,进件成功
  {
    path: "/trialSuccess_tl8",
    name: "TrialSuccessTl8",
    component: () => import("../views/trialSuccess_tl8"),
    meta: {
      title: "贷款申请已提交",
    },
  },
  // 进件结果,进件失败
  {
    path: "/trialSuccess_tl9",
    name: "TrialSuccessTl9",
    component: () => import("../views/trialSuccess_tl9.vue"),
    meta: {
      title: "贷款申请已提交",
    },
  },
  // H5还款计划
  {
    path: "/repaymentPlan",
    name: "RepaymentPlan",
    component: () => import("../views/repaymentPlan"),
    meta: {
      title: "还款计划",
    },
  },
  // 会员权益页面
  {
    path: "/member",
    name: "Member",
    component: () => import("../views/member"),
    meta: {
      title: "会员",
    },
  },
  //激活额度跳转页面
  {
    path: "/activeLimitDefauleJump",
    name: "activeLimitDefauleJump",
    component: () => import("../views/activeLimitDefauleJump"),
    meta: {
      title: "审批放款",
    },
  },

  // 匹配等待页面
  {
    path: "/matchWaiting",
    name: "MatchWaiting",
    component: () => import("../views/match/matchWaiting"),
    meta: {
      title: "资金匹配中",
    },
  },
  // 匹配成功结果详情页
  {
    path: "/matchResDetail",
    name: "MatchResDetail",
    component: () => import("../views/match/matchResDetail"),
    meta: {
      title: "确认申请",
    },
  },
  // 匹配成功结果详情页
  {
    path: "/applyWaiting",
    name: "ApplyWaiting",
    component: () => import("../views/match/applyWaiting"),
    meta: {
      title: "合同签署中",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});
router.beforeEach((to, from, next) => {
  var timestamp = new Date().getTime();
  to.query.tsp = timestamp;
  next();
});
export default router;
